import { useLocale } from '../hooks/useLocale'
import { ServiceIcon } from '../components/ServiceIcons'
import styles from './Services.module.css'

interface ServiceItem {
  title: string
  subtitle: string
  description: string
}

interface ServicesData {
  title: string
  items: ServiceItem[]
}

export default function Services() {
  const { get } = useLocale()
  const data = get('services') as ServicesData | undefined

  if (!data?.items?.length) return null

  return (
    <section className={styles.services} id="services" aria-labelledby="services-title">
      <div className={styles.container}>
        <h2 className={styles.title} id="services-title">
          {data.title}
        </h2>
        <div className={styles.grid}>
          {data.items.map((item, index) => (
            <article
              key={index}
              className={styles.card}
              aria-labelledby={`service-title-${index}`}
            >
              <div className={styles.cardIcon} aria-hidden>
                <ServiceIcon index={index} />
              </div>
              <h3 className={styles.cardTitle} id={`service-title-${index}`}>
                {item.title}
              </h3>
              <p className={styles.subtitle}>{item.subtitle}</p>
              <p className={styles.description}>{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
